module.exports = __webpack_public_path__ + "img/angela-sung-in-the-garden.48aa0fa.jpg";